// Hosted-checkout hand-off: full-page, same-tab navigation to the Lemon
// Squeezy checkout (checkout.steerly.ai). This replaces the old lemon.js
// embedded overlay on purpose — wallet buttons (Apple Pay / Google Pay)
// only render on a top-level page, never inside the embed iframe, and the
// hosted page shows the product + price summary. After payment LS sends the
// buyer back to the app via the redirect_url set server-side in
// convex/billing/checkout.ts.
export function openHostedCheckout(url: string): void {
  window.location.assign(url);
}
